(function(){
  if (window.__mnInit) return;
  window.__mnInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var once = function(el){ if(!el || el.dataset.mnInit) return false; el.dataset.mnInit='1'; return true; };

  /* ---------- reveals ---------- */
  var io = null;
  function initReveals(){
    var items = document.querySelectorAll('.mn-reveal:not([data-mn-rev])');
    if(!items.length) return;
    if(reduce){ items.forEach(function(e){ e.dataset.mnRev='1'; e.classList.add('mn-visible'); }); return; }
    if(!io){
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          var d = parseInt(en.target.dataset.mnDelay || 0, 10);
          setTimeout(function(){ en.target.classList.add('mn-visible'); }, d);
          io.unobserve(en.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    items.forEach(function(e){ e.dataset.mnRev='1'; io.observe(e); });
  }

  /* ---------- rail arrastrable + cursor ---------- */
  function initRail(){
    document.querySelectorAll('.mn-rail__wrap').forEach(function(w){
      if(!once(w)) return;
      var down=false, x0=0, s0=0, moved=0;
      w.addEventListener('pointerdown', function(e){
        if(e.pointerType==='touch') return;
        down=true; moved=0; x0=e.clientX; s0=w.scrollLeft; w.classList.add('mn-arrastrando');
      });
      w.addEventListener('pointermove', function(e){
        if(!down) return;
        var d = e.clientX - x0; moved = Math.abs(d);
        w.scrollLeft = s0 - d;
        if(moved > 6) e.preventDefault();
      });
      ['pointerup','pointerleave','pointercancel'].forEach(function(ev){
        w.addEventListener(ev, function(){ down=false; w.classList.remove('mn-arrastrando'); });
      });
      w.addEventListener('click', function(e){ if(moved > 6){ e.preventDefault(); e.stopPropagation(); } }, true);

      if(window.matchMedia('(min-width: 990px)').matches){
        var cur = document.createElement('div');
        cur.className = 'mn-cursor';
        cur.textContent = w.dataset.mnCursor || 'Arrastra';
        document.body.appendChild(cur);
        w.addEventListener('pointerenter', function(){ cur.classList.add('mn-on'); });
        w.addEventListener('pointerleave', function(){ cur.classList.remove('mn-on'); });
        w.addEventListener('pointermove', function(e){ cur.style.left = e.clientX + 'px'; cur.style.top = e.clientY + 'px'; });
      }
    });
  }

  /* ---------- frase que se ilumina ---------- */
  function initFrase(){
    document.querySelectorAll('.mn-frase').forEach(function(f){
      if(!once(f)) return;
      var words = f.querySelectorAll('.mn-frase__w');
      if(!words.length) return;
      if(reduce){ words.forEach(function(w){ w.classList.add('mn-on'); }); return; }
      var tick = function(){
        var r = f.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh * 0.86 - r.top) / (r.height + vh * 0.36);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * words.length);
        words.forEach(function(w, i){ w.classList.toggle('mn-on', i < n); });
      };
      var pend = false;
      var onScroll = function(){
        if(pend) return; pend = true;
        requestAnimationFrame(function(){ pend = false; tick(); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      tick();
    });
  }

  /* ---------- comparador ---------- */
  function initComparador(){
    document.querySelectorAll('.mn-cmp').forEach(function(c){
      if(!once(c)) return;
      var filas = c.querySelectorAll('.mn-cmp__fila');
      var fotos = c.querySelectorAll('.mn-cmp__escena img');
      var activar = function(i){
        filas.forEach(function(f, j){ f.classList.toggle('mn-on', i === j); f.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        fotos.forEach(function(f, j){ f.classList.toggle('mn-on', i === j); });
      };
      filas.forEach(function(f, i){
        f.addEventListener('click', function(){ activar(i); });
        f.addEventListener('mouseenter', function(){ activar(i); });
        f.addEventListener('focus', function(){ activar(i); });
      });
      activar(0);
    });
  }

  /* ---------- faq ---------- */
  function initFaq(){
    document.querySelectorAll('.mn-faq__b').forEach(function(b){
      if(!once(b)) return;
      b.addEventListener('click', function(){
        var item = b.closest('.mn-faq__i');
        var abierto = item.classList.contains('mn-on');
        var lista = b.closest('.mn-faq');
        if(lista && lista.dataset.mnSolo === 'true'){
          lista.querySelectorAll('.mn-faq__i').forEach(function(o){ o.classList.remove('mn-on'); o.querySelector('.mn-faq__b').setAttribute('aria-expanded','false'); });
        }
        item.classList.toggle('mn-on', !abierto);
        b.setAttribute('aria-expanded', (!abierto).toString());
      });
    });
  }

  /* ---------- parallax del cierre ---------- */
  function initParallax(){
    document.querySelectorAll('.mn-cierre').forEach(function(c){
      if(!once(c)) return;
      var img = c.querySelector('.mn-cierre__foto');
      if(!img || reduce) return;
      var fuerza = parseFloat(c.dataset.mnParallax || '0.12');
      var pend = false;
      var tick = function(){
        var r = c.getBoundingClientRect();
        var vh = window.innerHeight;
        if(r.bottom < 0 || r.top > vh) return;
        var centro = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = 'translate3d(0,' + (centro * fuerza * 100).toFixed(2) + 'px,0)';
      };
      window.addEventListener('scroll', function(){
        if(pend) return; pend = true;
        requestAnimationFrame(function(){ pend = false; tick(); });
      }, { passive: true });
      tick();
    });
  }

  /* ---------- cuenta atras -----------------------------------------------
     Dos modos:
     - ciclica (data-mn-ciclo="horas"): se reinicia sola. Ancla fija (no
       editable): el ciclo se calcula como "ahora - ancla, modulo duracion",
       asi que todos los visitantes ven el mismo resto en el mismo instante
       real (no se reinicia por visita ni por persona).
     - hasta una fecha (data-mn-fin-s="<segundos epoch>"): termina de verdad.
       Con data-mn-fin-ocultar="1" la seccion entera desaparece al llegar a 0. */
  var MN_CICLO_ANCLA = new Date('2024-01-01T00:00:00').getTime();
  function initCuenta(){
    document.querySelectorAll('[data-mn-cuenta]').forEach(function(el){
      if(!once(el)) return;
      var finMs = parseFloat(el.dataset.mnFinS || '0') * 1000;
      var horas = parseFloat(el.dataset.mnCiclo || '0');
      if(!finMs && (!horas || horas <= 0)) return;
      var cicloMs = horas * 3600 * 1000;
      var dEl = el.querySelector('[data-mn-d]');
      var hEl = el.querySelector('[data-mn-h]');
      var mEl = el.querySelector('[data-mn-m]');
      var sEl = el.querySelector('[data-mn-s]');
      var pad = function(n){ return String(n).padStart(2, '0'); };
      var intervalo;
      var pintar = function(restante){
        var s = Math.floor(restante / 1000);
        if(s < 0) s = 0;
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        if(dEl) dEl.textContent = d;
        if(hEl) hEl.textContent = pad(h);
        if(mEl) mEl.textContent = pad(m);
        if(sEl) sEl.textContent = pad(s);
      };
      var terminar = function(){
        if(intervalo) clearInterval(intervalo);
        pintar(0);
        if(el.dataset.mnFinOcultar === '1'){
          var sec = el.closest('.shopify-section');
          if(sec){ sec.dataset.mnFin = '1'; sec.style.display = 'none'; }
          else el.hidden = true;
        }
      };
      var tick = function(){
        var restante;
        if(finMs){
          restante = finMs - Date.now();
          if(restante <= 0){ terminar(); return; }
        } else {
          var transcurrido = (Date.now() - MN_CICLO_ANCLA) % cicloMs;
          if(transcurrido < 0) transcurrido += cicloMs;
          restante = cicloMs - transcurrido;
        }
        pintar(restante);
      };
      tick();
      intervalo = setInterval(tick, 1000);
    });
  }

  /* ---------- barra de urgencia de la ficha ------------------------------
     Se reescribe sola cuando la clienta cambia de talla o color: el descuento
     y las unidades son los de ESA variante, no los del producto en general.
     Los datos vienen del JSON que pinta mn-urgencia.liquid; el aviso de
     cambio lo lanza mn-tienda.js con el evento 'mn:variante'. */
  function initUrgencia(){
    document.querySelectorAll('[data-mn-urg]').forEach(function(barra){
      if(!once(barra)) return;
      var seccion = barra.closest('.shopify-section');
      var fuente = (seccion || document).querySelector('[data-mn-urg-datos]');
      var datos = {};
      if(fuente){
        try { datos = JSON.parse(fuente.textContent); } catch(e){ datos = {}; }
      }
      var txt = barra.querySelector('[data-mn-urg-txt]');
      var reloj = barra.querySelector('[data-mn-urg-reloj]');
      var motivo = barra.dataset.mnUrgMotivo || 'mensaje';
      var umbral = parseInt(barra.dataset.mnUrgUmbral || '0', 10);
      var sinStock = barra.dataset.mnUrgSinstock === '1';
      var libre = barra.dataset.mnUrgBase || '';
      var fijo = barra.dataset.mnUrgFijo || '';
      var plantillaDesc = barra.dataset.mnUrgDesc || '';
      var plantillaStock = barra.dataset.mnUrgPlantilla || '';
      var rellenar = function(plantilla, clave, valor){
        return String(plantilla).split(clave).join(valor);
      };

      var aplicar = function(d){
        var nuevo = fijo;
        var conReloj = true;
        if(motivo === 'descuento'){
          if(d.r){
            nuevo = rellenar(plantillaDesc, '{descuento}', d.p + ' %');
            nuevo = rellenar(nuevo, '{ahorro}', d.a);
          } else {
            nuevo = libre;
            conReloj = false;
          }
        }
        if(!sinStock && d.u > 0 && umbral > 0 && d.u <= umbral){
          nuevo = rellenar(plantillaStock, '{unidades}', d.u);
        }
        if(txt) txt.textContent = nuevo;
        if(reloj) reloj.hidden = !conReloj;
        /* si la cuenta atras ya llego a cero, la seccion se queda escondida */
        if(seccion && seccion.dataset.mnFin !== '1'){
          seccion.style.display = (!nuevo && !conReloj) ? 'none' : '';
        }
      };

      document.addEventListener('mn:variante', function(ev){
        var id = ev && ev.detail && ev.detail.id;
        if(!id) return;
        var d = datos[String(id)];
        if(d) aplicar(d);
      });
    });
  }

  /* ---------- cifras que suben (count-up, una sola vez) ---------- */
  function mnParseCifra(s){
    s = String(s || '').replace(/\s/g, '');
    if(s === '') return null;
    if(/^\d+$/.test(s)) return { v: parseFloat(s), d: 0 };
    if(/^\d{1,3}([.,]\d{3})+$/.test(s)) return { v: parseFloat(s.replace(/[.,]/g, '')), d: 0 };
    var m = s.match(/^(\d[\d.,]*)[.,](\d{1,2})$/);
    if(m) return { v: parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[2]), d: m[2].length };
    return null;
  }
  var ioCif = null;
  function initCifras(){
    var els = document.querySelectorAll('[data-mn-cifra]');
    if(!els.length) return;
    var arrancar = function(el){
      var dato = mnParseCifra(el.dataset.mnCifra);
      if(!dato) return;
      var dur = parseInt(el.dataset.mnDur || 1600, 10);
      var fin = dato.v, dec = dato.d;
      var fmt = function(n){
        try { return n.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
        catch(e){ return n.toFixed(dec); }
      };
      var t0 = null;
      var paso = function(ts){
        if(t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(fin * e);
        if(p < 1) requestAnimationFrame(paso);
        else el.textContent = fmt(fin);
      };
      requestAnimationFrame(paso);
    };
    els.forEach(function(el){
      if(!once(el)) return;
      if(reduce || !mnParseCifra(el.dataset.mnCifra)) return;
      el.textContent = '0';
      if(!('IntersectionObserver' in window)){ arrancar(el); return; }
      if(!ioCif){
        ioCif = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(!en.isIntersecting) return;
            ioCif.unobserve(en.target);
            arrancar(en.target);
          });
        }, { threshold: 0.35, rootMargin: '0px 0px -6% 0px' });
      }
      ioCif.observe(el);
    });
  }

  function initTodo(){
    initReveals(); initRail(); initFrase(); initComparador(); initFaq(); initParallax(); initCuenta(); initCifras(); initUrgencia();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
  document.addEventListener('shopify:section:load', initTodo);
})();
